import axios from "axios";
var base64 = require("base-64");
import cookie from "react-cookies";
import brand from "dan-api/dummy/brand";

// Action types
export const BONUS_CAMPAIGN_LOADING = "bonus_campaign_loading";
export const BONUS_CAMPAIGN_RULES = "bonus_campaign_rules";
export const BONUS_CAMPAIGN_ERROR = "bonus_campaign_error";
export const BONUS_CAMPAIGN_FORM_DATA = "bonus_campaign_form_data";
export const BONUS_CAMPAIGN_REGIONS = "bonus_campaign_regions";

let initialState = {
  loading: false,
  error: "",
  campaigns: [],
  regions: [],
  formData: {
    ruleName: "",
    startDate: "",
    endDate: "",
    creationDate: new Date().toISOString().split("T")[0],
    isActive: true,
    selectedRegions: [],
    brandId: "",
    bonusRanges: [],
  },
};

/**
 * Fetch bonus campaign rules from API based on brandId
 */
export async function getBonusRules() {
  return async (dispatch) => {
    dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: true });

    const paketYoldaId = cookie.load("PaketYoldaId");

    await axios({
      method: "GET",
      url:
        brand.urlSocketPaketYolda +
        "api/BonusRule/GetBonusRules?brandId=" +
        paketYoldaId,
      dataType: "json",
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    })
      .then(function(response) {
        if (response.data.isStatus) {
          // API response is already in JSON format, no need to parse again
          let campaigns = response.data.responseData;

          // If it's a string (which it shouldn't be), try to parse it
          if (typeof campaigns === "string") {
            try {
              campaigns = JSON.parse(campaigns);
            } catch (e) {
              console.error("Error parsing campaigns:", e);
              campaigns = [];
            }
          }

          // Ensure campaigns is an array
          if (!Array.isArray(campaigns)) {
            campaigns = [];
          }

          // No need for transformation as the API response matches our needs
          dispatch({ type: BONUS_CAMPAIGN_RULES, payload: campaigns });
        } else {
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
        }
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: BONUS_CAMPAIGN_ERROR,
          payload: "An error occurred while fetching bonus rules",
        });
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      });
  };
}

/**
 * Fetch regions list from API
 */
export async function getRegionsList() {
  return async (dispatch) => {
    dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: true });

    const paketYoldaId = cookie.load("PaketYoldaId");

    await axios({
      method: "GET",
      url:
        brand.urlSocketPaketYolda +
        "api/Settings/getRegionList?BrandId=" +
        paketYoldaId,
      dataType: "json",
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    })
      .then(function(response) {
        if (response.data.isStatus) {
          const json = JSON.parse(response.data.responseData);
          dispatch({ type: BONUS_CAMPAIGN_REGIONS, payload: json });
        } else {
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
        }
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: BONUS_CAMPAIGN_ERROR,
          payload: "An error occurred while fetching regions",
        });
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      });
  };
}

/**
 * Add or update a bonus campaign rule
 */
export async function setBonusRule(data) {
  return async (dispatch) => {
    dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: true });

    // Transform the data to match the API's expected format
    const requestData = {
      Id: data.Id || "00000000-0000-0000-0000-000000000000",
      RuleName: data.RuleName,
      StartDate: data.StartDate,
      EndDate: data.EndDate,
      Status: data.Status,
      Regions: data.Regions || [],
      BrandId: data.BrandId,
      BonusRanges: (data.BonusRanges || []).map((range) => ({
        StartingValue: range.StartingValue,
        EndValue: range.EndValue,
        BonusAmount: range.BonusAmount,
      })),
    };

    console.log("Sending request data:", JSON.stringify(requestData, null, 2));

    await axios({
      method: "POST",
      url: brand.urlSocketPaketYolda + "api/BonusRule/setBonusRule",
      dataType: "json",
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
        "Content-Type": "application/json",
      },
      data: requestData,
    })
      .then(function(response) {
        if (response.data.isStatus) {
          // After successful creation, fetch the updated list
          dispatch(getBonusRules());
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: "Bonus rule saved successfully",
          });
        } else {
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
          dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
        }
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: BONUS_CAMPAIGN_ERROR,
          payload: "An error occurred while saving the bonus rule",
        });
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      });
  };
}

/**
 * Update form data
 */
export async function updateFormData(field, value) {
  return {
    type: BONUS_CAMPAIGN_FORM_DATA,
    payload: { field, value },
  };
}

/**
 * Reset form data to initial state
 */
export async function resetFormData() {
  return async (dispatch) => {
    dispatch({
      type: BONUS_CAMPAIGN_FORM_DATA,
      payload: {
        field: "formData",
        value: {
          ruleName: "",
          startDate: "",
          endDate: "",
          creationDate: new Date().toISOString().split("T")[0],
          isActive: true,
          selectedRegions: [],
          brandId: cookie.load("BrandId"),
          bonusRanges: [],
        },
      },
    });
  };
}

/**
 * Toggle bonus rule status (Active/Passive)
 */
export async function toggleBonusRuleStatus(id) {
  return async (dispatch) => {
    dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: true });

    await axios({
      method: "GET",
      url:
        brand.urlSocketPaketYolda +
        `api/BonusRule/toggleBonusRuleStatus?id=${id}`,
      dataType: "json",
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    })
      .then(function(response) {
        if (response.data.isStatus) {
          // After successful toggle, fetch the updated list
          dispatch(getBonusRules());
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
        } else {
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
          dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
        }
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: BONUS_CAMPAIGN_ERROR,
          payload: "Durum değiştirme işlemi sırasında bir hata oluştu",
        });
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      });
  };
}

/**
 * Delete a bonus rule
 */
export async function deleteBonusRule(id) {
  return async (dispatch) => {
    dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: true });

    await axios({
      method: "GET",
      url: brand.urlSocketPaketYolda + `api/BonusRule/deleteBonusRule?id=${id}`,
      dataType: "json",
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    })
      .then(function(response) {
        if (response.data.isStatus) {
          // After successful deletion, fetch the updated list
          dispatch(getBonusRules());
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
        } else {
          dispatch({
            type: BONUS_CAMPAIGN_ERROR,
            payload: response.data.responseData,
          });
          dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
        }
      })
      .catch(function(error) {
        console.log(error);
        dispatch({
          type: BONUS_CAMPAIGN_ERROR,
          payload: "Silme işlemi sırasında bir hata oluştu",
        });
        dispatch({ type: BONUS_CAMPAIGN_LOADING, payload: false });
      });
  };
}

// Reducer
const BonusRuleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case BONUS_CAMPAIGN_LOADING:
      return { ...state, loading: action.payload };
    case BONUS_CAMPAIGN_RULES:
      return { ...state, campaigns: action.payload };
    case BONUS_CAMPAIGN_REGIONS:
      return { ...state, regions: action.payload };
    case BONUS_CAMPAIGN_ERROR:
      return { ...state, error: action.payload };
    case BONUS_CAMPAIGN_FORM_DATA:
      const { field, value } = action.payload;
      if (field === "formData") {
        return { ...state, formData: value };
      }
      return {
        ...state,
        formData: {
          ...state.formData,
          [field]: value,
        },
      };
    default:
      return state;
  }
};

export default BonusRuleReducer;
